var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "c-button",
      class: {
        "c-button_responsive": _vm.responsive !== undefined,
        "c-button_nolabel": _vm.label === undefined,
        "c-button_with-icon": _vm.icon !== undefined,
        "c-button_active": _vm.activeLocal,
        "c-button_color_blue": _vm.color === "blue",
        "c-button_color_pink": _vm.color === "pink",
        "c-button_noborder": _vm.noBorder !== undefined,
        "c-button_size_small": _vm.size === "small",
        "c-button_size_large": _vm.size === "large",
        "c-button_active-color_blue": _vm.activeColor === "blue",
        "c-button_disabled": _vm.disabled,
        "c-button_pending": _vm.pending,
      },
      attrs: { id: `c-button-${_vm._uid}`, type: _vm.type || "button" },
    },
    [
      _c(
        "div",
        { staticClass: "c-button__wrapper", on: { click: _vm.click } },
        [
          _vm.icon !== undefined
            ? _c(
                "div",
                { staticClass: "c-button__icon" },
                [
                  _c("c-icon", {
                    attrs: {
                      icon:
                        typeof _vm.icon === "string" ? _vm.icon : _vm.icon.icon,
                      color: _vm.getIconColor(),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.label !== undefined
            ? _c("div", { staticClass: "c-button__label" }, [
                _vm._v(" " + _vm._s(_vm.getLabel()) + " "),
              ])
            : _vm._e(),
          _vm.pending
            ? _c(
                "div",
                { staticClass: "c-button__pending" },
                [
                  _c("font-awesome-icon", {
                    style: {
                      color: _vm.getIconColor(),
                    },
                    attrs: { icon: _vm.spinner, spin: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.tooltip !== undefined
        ? _c(
            "b-popover",
            {
              attrs: {
                triggers: "hover",
                placement: "top",
                target: `c-button-${_vm._uid}`,
              },
            },
            [_vm._v(" " + _vm._s(_vm.getPopoverContent()) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }